export const Colors = [
    "#0070FF", "#5CA4FF", "#B1D8FF", "#36CCED",
    "#02B555", "#099B9B", "#865EFA", "#F91101",
    "#FF460B", "#FF8A00", "#FFD41B", "#DEFFF9",
    "#E6FFE3", "#E0E0E0", "#FFE2E8", "#03011D"
];